"use strict";
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
Object.defineProperty(exports, "__esModule", { value: true });
const i0 = require("@angular/core");
const i1 = require("./keyboard-navigator.component");
const i2 = require("../../../commons/map.service");
const i3 = require("../../../service/plugin-manager.service");
var styles_KeyboardNavigatorComponent = [];
var RenderType_KeyboardNavigatorComponent = i0.ɵcrt({ encapsulation: 2, styles: styles_KeyboardNavigatorComponent, data: {} });
exports.RenderType_KeyboardNavigatorComponent = RenderType_KeyboardNavigatorComponent;
function View_KeyboardNavigatorComponent_0(_l) { return i0.ɵvid(0, [], null, null); }
exports.View_KeyboardNavigatorComponent_0 = View_KeyboardNavigatorComponent_0;
function View_KeyboardNavigatorComponent_Host_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "app-keyboard-navigator", [], null, null, null, View_KeyboardNavigatorComponent_0, RenderType_KeyboardNavigatorComponent)), i0.ɵdid(1, 245760, null, 0, i1.KeyboardNavigatorComponent, [i2.MapService, i3.PluginManagerService], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
exports.View_KeyboardNavigatorComponent_Host_0 = View_KeyboardNavigatorComponent_Host_0;
var KeyboardNavigatorComponentNgFactory = i0.ɵccf("app-keyboard-navigator", i1.KeyboardNavigatorComponent, View_KeyboardNavigatorComponent_Host_0, {}, {}, []);
exports.KeyboardNavigatorComponentNgFactory = KeyboardNavigatorComponentNgFactory;
